/* 
 * @Author: 曹俊杰 
 * @Date: 2022-11-25 11:46:00
 * @Module: 筛选表单
 */
 <template>
  <el-form :inline="true" :model="searchForm" size="mini" style="margin-top:20px;">
    <el-form-item label="客户名称">
      <el-input v-model="searchForm.keyword" placeholder="搜索客户名称或编号" clearable></el-input>
    </el-form-item>
    <el-form-item label="项目名称">
      <projectName v-model="searchForm.projectName"></projectName>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">查询</el-button>
    </el-form-item>
  </el-form>
</template>
 <script>
import projectName from "./form/projectName.vue";
export default {
  components: {
    projectName
  },
  props: {
    searchForm: {
      type: Object,
      default: () => ({
        keyword: '',
        projectName: ''
      })
    }
  },
  data () {
    return {
    };
  },
  mounted () { },
  methods: {
    onSubmit () {
      this.$emit('submit')
    }
  },
};
 </script>
 <style lang='scss' scoped>
</style>